import { render, staticRenderFns } from "./otp_settings.vue?vue&type=template&id=635dadab&"
import script from "./otp_settings.vue?vue&type=script&lang=js&"
export * from "./otp_settings.vue?vue&type=script&lang=js&"
import style0 from "./otp_settings.vue?vue&type=style&index=0&id=635dadab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports